function setThemeColor(color) {
    document.getElementById("theme-color").content = color;
}

export default setThemeColor;
